// ============================================================
// Dashboard Stats Mock Data
// ============================================================

export const mockDashboardStats = {
  'school-001': {
    owner: {
      totalStudents: 1250,
      presentToday: 1180,
      absentToday: 70,
      monthlyCollection: 380000,
      pendingFees: 150000,
      newAdmissions: 45,
    },
    principal: {
      totalStudents: 1250,
      presentToday: 1180,
      absentToday: 70,
      monthlyCollection: 380000,
      pendingFees: 150000,
      newAdmissions: 45,
    },
    reception: {
      totalStudents: 1250,
      newAdmissions: 45,
      todaysAdmissions: 3,
      studentRequests: 12,
    },
    accountant: {
      todaysCollection: 25000,
      monthlyCollection: 380000,
      pendingFees: 150000,
      todaysReceipts: 42,
    }
  },
  'school-002': {
    owner: {
      totalStudents: 980,
      presentToday: 920,
      absentToday: 60,
      monthlyCollection: 280000,
      pendingFees: 120000,
      newAdmissions: 28,
    },
    principal: {
      totalStudents: 980,
      presentToday: 920,
      absentToday: 60,
      monthlyCollection: 280000,
      pendingFees: 120000,
      newAdmissions: 28,
    },
    reception: {
      totalStudents: 980,
      newAdmissions: 28,
      todaysAdmissions: 1,
      studentRequests: 5,
    },
    accountant: {
      todaysCollection: 18000,
      monthlyCollection: 280000,
      pendingFees: 120000,
      todaysReceipts: 25,
    }
  },
  'school-003': {
    owner: {
      totalStudents: 670,
      presentToday: 640,
      absentToday: 30,
      monthlyCollection: 195000,
      pendingFees: 85000,
      newAdmissions: 18,
    },
    principal: {
      totalStudents: 670,
      presentToday: 640,
      absentToday: 30,
      monthlyCollection: 195000,
      pendingFees: 85000,
      newAdmissions: 18,
    },
    reception: {
      totalStudents: 670,
      newAdmissions: 18,
      todaysAdmissions: 0,
      studentRequests: 2,
    },
    accountant: {
      todaysCollection: 12000,
      monthlyCollection: 195000,
      pendingFees: 85000,
      todaysReceipts: 15,
    }
  },
};
